export const registerRoutes = {
  name: 'register',
  path: '/register',
  component: () => import('pages/Register/index.vue'),
  meta: {
    title: 'Register',
  },
}
